import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-daisyui';

interface ExportConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onExport: () => void;
  selectedData?: Set<any>; // optional
  title?: string;  // optional
  content?: React.ReactNode;  // optional
}

const ExportConfirmationModal: React.FC<ExportConfirmationModalProps> = ({
  isOpen,
  onClose,
  onExport,
  selectedData,
  title = 'Confirm Modal', // Default value for title
  content = (<><p>Please confirm the action.</p></>), // Default value for content
}) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    isOpen && setLoading(false);
  }, [isOpen]);

  return (
    <Modal open={isOpen}>
      <Modal.Header className="font-bold">{title}</Modal.Header>

      <Modal.Body>
        {content}
      </Modal.Body>

      <Modal.Actions>
        <Button id='ModalCancelButton' type="button" disabled={loading} onClick={onClose}>
          Cancel
        </Button>
        <Button
          id='ModalConfirmButton' 
          type="button"
          color="primary"
          className={loading ? 'pointer-events-none' : ''}
          onClick={loading ? undefined : onExport}
        >
          {loading ? (
            <div className="flex items-center">
              <svg
                className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              Loading...
            </div>
          ) : (
            'Export'
          )}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ExportConfirmationModal;
